/**
 * @description - _polyfill.js: Cross-browser polyfills for es6 (mostly ie11 and below)
 *
 * @author - Ruud Timmermans <r.timmermans@bluedragon.nl>
 */

import 'classlist-polyfill';
import 'url-search-params-polyfill';

// Object entries
if (!Object.entries) {
    Object.entries = function(obj) {
        const ownProps = Object.keys( obj );
        let i = ownProps.length;
        const resArray = new Array(i);
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }

        return resArray;
    };
}

// Nodelist forEach
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// element.closest()
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        let el = this;

        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

if (!HTMLFormElement.prototype.requestSubmit) {
    HTMLFormElement.prototype.requestSubmit = function() {
        const submitBtn = document.createElement('input');
        submitBtn.type = 'submit';
        submitBtn.hidden = true;
        this.appendChild(submitBtn);
        submitBtn.click();
        this.removeChild(submitBtn);
    };
}

if (!HTMLFormElement.prototype.reportValidity) {
    HTMLFormElement.prototype.reportValidity = function() {
        if (this.checkValidity()) {
            return true;
        }
        if (this.noValidate) {
            this.noValidate = false;
            this.requestSubmit();
            this.noValidate = true;
        } else {
            this.requestSubmit();
        }
        return false;
    };
}
